<app-dialog-header [title]="isCreate ? 'general.api_templates_form_create_title' : 'general.api_templates_form_edit_title'"
                   [withConfirm]="true" (closed)="confirmClose()"></app-dialog-header>
<div class="dialog-info" *ngIf="isView">
  <div class="flex flex-grow">
    <!-- Key -->
    <app-label-value class="break-word" [label]="'general.api_templates_table_key'" [value]="translation.key"></app-label-value>
    <!-- Language -->
    <ng-container [ngTemplateOutlet]="languageTemplate"></ng-container>
  </div>
</div>
<mat-dialog-content>
  <ng-container *ngIf="!isView">
    <div class="flex flex-grow" >
      <!-- Key -->
      <app-text-input [label]="'general.api_templates_table_key'" [(value)]="translation.key"></app-text-input>
      <!-- Language -->
      <ng-container [ngTemplateOutlet]="languageTemplate"></ng-container>
    </div>
    <hr>
  </ng-container>
  <app-label-value [label]="'general.api_templates_form_content'" [template]="translationsTemplate" [withMargin]="true"></app-label-value>
  <ng-template #translationsTemplate>
    <ng-container *ngIf="isView || previewMode">
      <hr class="slim">
      <iframe class="bottom-spacer max-width" [style]="{border: 0}" [srcdoc]="html"></iframe>
    </ng-container>
    <ng-container *ngFor="let language of sortedLanguages">
      <ng-container *ngIf="selectedLanguage === language">
        <angular-editor class="bottom-spacer" [ngClass]="{'editor-warning': isMaxCharLimitExceeded}" *ngIf="(isEdit || isCreate) && !previewMode"
                        [placeholder]="'general.api_templates_table_lang_' + selectedLanguage | translate" [config]="editorConfig"
                        [(ngModel)]="translation.translations[selectedLanguage]" [id]="'lang_' + language"></angular-editor>
        <small *ngIf="isMaxCharLimitExceeded" class="text-warning">
          <mat-icon class="svg-icon" [svgIcon]="'warning'"></mat-icon>
          {{ 'general.api_templates_form_content_too_long' | translate }}
        </small>
      </ng-container>
    </ng-container>
  </ng-template>
  <br>
</mat-dialog-content>
<app-dialog-footer [dialogActions]="dialogActions"></app-dialog-footer>
<ng-template #dialogActions>
  <button mat-button (click)="confirmClose()">{{(isView ? 'general.api_general_close' : 'general.api_templates_form_cancel')  | translate}}</button>
  <button mat-stroked-button color="primary" *ngIf="(isEdit || isCreate) && !previewMode" (click)="preview()">{{'general.api_templates_form_preview' | translate}}</button>
  <button mat-stroked-button color="primary" *ngIf="previewMode" (click)="editMode()">{{'general.api_templates_form_edit' | translate}}</button>
  <button mat-flat-button color="primary" *ngIf="isCreate" [disabled]="!isValid" (click)="isValid && create()">{{'general.api_templates_form_create' | translate}}</button>
  <button mat-flat-button color="primary" *ngIf="isEdit" [disabled]="!isValid" (click)="isValid && update()">{{'general.api_templates_form_save' | translate}}</button>
  <button mat-flat-button color="primary" *ngIf="isView" (click)="edit()">{{'general.api_templates_form_edit' | translate}}</button>
</ng-template>
<ng-template #languageTemplate>
  <mat-form-field appearance="outline" class="no-hint">
    <mat-label>{{ 'general.api_templates_table_languages' | translate }}</mat-label>
    <mat-select [(ngModel)]="selectedLanguage" (ngModelChange)="sanitizedHtml($event)" [ngModelOptions]="{standalone: true}">
      <mat-option *ngFor="let language of sortedLanguages" [value]="language">
        {{ 'general.api_translations_table_lang_' + language | translate }}
        <ng-container *ngIf="language === 'en'">*</ng-container>
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-template>
